<template>
  <el-form
      class="login-form"
      status-icon
      :rules="loginRules"
      ref="loginForm"
      :model="loginForm"
      label-width="0">
    <el-form-item prop="username">
      <el-input
          size="small"
          @keyup.enter.native="handleLogin"
          v-model="loginForm.username"
          auto-complete="off"
          placeholder="请输入账号">
        <i
            slot="prefix"
            class="icon-yonghu"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input
          size="small"
          @keyup.enter.native="handleLogin"
          :type="passwordType"
          v-model="loginForm.password"
          auto-complete="off"
          placeholder="密码">
        <i
            class="el-icon-view el-input__icon"
            slot="suffix"
            @click="showPassword"></i>
        <i
            slot="prefix"
            class="icon-mima"></i>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button
          type="primary"
          size="small"
          @click.native.prevent="handleLogin"
          class="login-submit">登录
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  name: 'UserLogin',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, message: '密码长度最少为6位', trigger: 'blur' }
        ]
      },
      passwordType: 'password'
    }
  },
  methods: {
    showPassword () {
      this.passwordType === ''
        ? (this.passwordType = 'password')
        : (this.passwordType = '')
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$store.dispatch('LoginByUsername', this.loginForm).then((res) => {
            this.$store.dispatch('GetUserInfo')
            this.$router.push({ path: '/' })
          }).catch(err => {
            this.$message.error(err.msg || '登录失败')
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
